import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class DestinationsCard extends Component {
    redirectToPage = () => {
        const { history } = this.props;
        if (history) {
            history.push(this.props.navigateTo);
        }
        var destinationlink = document.getElementById("destination-link");
        var current = document.getElementsByClassName("active");
        current[0].className = current[0].className.replace('active', '');
        destinationlink.className += 'active';
    }
    render() {
        const { history } = this.props;
        return (
            <section className='destination-card' >
                {
                    history ? (
                        <img src={this.props.src} alt={this.props.alt} onClick={this.redirectToPage}></img>
                    ) : null
                }
                <div className='place-detail' >
                    <p > {this.props.title} </p>

                    <button
                        type='button'
                        className='redirect' > {this.props.places} </button>
                </div>
            </section>
        )
    }
}
export default withRouter(DestinationsCard)